// src/components/CustomFields/fields/DOMHelper.ts
// Utility functions migrated from legacy DOMHelper.js

import $ from 'jquery';

export function isSafari(): boolean
{
  const ua = navigator.appVersion;
  return (
    ua.search('Safari') !== -1 &&
    ua.search('Chrome') === -1 &&
    ua.search('CrMo') === -1 &&
    ua.search('CriOS') === -1
  );
}

export function isFirefox(): boolean
{
  return typeof window !== 'undefined' && 'netscape' in window && /rv:/.test(navigator.userAgent);
}

export function getScrollTop(containerElement: JQuery<HTMLElement>): number
{
  let scrollTop = 0;

  if (containerElement.closest('.sortableDashboard').length > 0)
  {
    scrollTop = containerElement.closest('.sortableDashboard').scrollTop() || 0;
  }
  if (scrollTop === 0 && containerElement.closest('.layer-details-container').length > 0)
  {
    scrollTop = containerElement.closest('.layer-details-container').scrollTop() || 0;
  }
  if (scrollTop === 0 && containerElement.closest('.add-inline-task').length > 0)
  {
    scrollTop = containerElement.closest('.add-inline-task').scrollTop() || 0;
  }
  if (scrollTop === 0 && containerElement.closest('.card-body-area').length > 0)
  {
    scrollTop = containerElement.closest('.card-body-area').scrollTop() || 0;
  }
  if (scrollTop === 0 && containerElement.closest('md-dialog-content').length > 0)
  {
    scrollTop = containerElement.closest('md-dialog-content').scrollTop() || 0;
  }
  if (scrollTop == null || scrollTop === 0)
  {
    scrollTop = $('body.core2').scrollTop() || 0;
  }

  return scrollTop;
}

export function dropDownFixPosition(
  button: JQuery<HTMLElement>,
  dropdown: JQuery<HTMLElement>,
  showRight?: boolean,
  pixelsLeft?: number,
): void
{
  let dropDownTop =
    (button.offset()?.top || 0) + button.outerHeight()! - ($('body.core2').scrollTop() || 0);

  let posLeft = 0;
  if (pixelsLeft)
  {
    posLeft = (button.offset()?.left || 0) - pixelsLeft;
  }
  else
  {
    posLeft = button.offset()?.left || 0;
  }

  dropdown.addClass('positionFixed');
  if (showRight)
  {
    dropDownTop = (button.offset()?.top || 0) - ($('body.core2').scrollTop() || 0);
    posLeft += button.outerWidth()!;
  }
  dropdown.css('top', dropDownTop + 'px');
  dropdown.css('left', posLeft + 'px');
}
